// extracted by mini-css-extract-plugin
export default {"assistants":"AssistantsPage_assistants__X-8vR","ant-collapse-header":"AssistantsPage_ant-collapse-header__riNbl"};